import { FC } from "react";
import LoaderComponent from "../../../../common/components/loader/loader.component";

const OrderDetailsLoaderComponent: FC = () => {
  return (
    <div className="order_details_loader_wrapper">
      <LoaderComponent type="primary" />
    </div>
  );
};

export default OrderDetailsLoaderComponent;
